<template>
  <div>
    <div class="banner-swiper-native">
      <div class="banner-wrapper" ref="bannerWrapper">
        <div class="banner-slide" v-for="(item, index) in swiperList" :key="index">
          <img :src="imgUrl + item.image" alt="" class="banner-img" v-if="item.image" />
          <img :src="imgUrl + item" alt="" class="banner-img" v-else />
        </div>
        <div class="banner-slide" v-if="swiperList.length">
          <img :src="imgUrl + swiperList[0].image" alt="" class="banner-img" />
        </div>
      </div>
      <div class="flex dotall">
        <div v-for="(item, index) in swiperList" :key="index" class="dot" :class="{ 'active': bannerCurrent == index }" @click="goToBanner(index)">
        </div>
      </div>
    </div>


  </div>
</template>

<script>

export default {
  name: 'banner',
  props: {
    swiperList: {
      default: () => []
    }
  },
  data() {
    return {
      imgUrl: this.$imgUrl,
      bannerTimer: null,
      bannerCurrent: 0
    };
  },
  watch: {
    swiperList: {
      handler(newVal) {
        this.clearBannerTimer();
        if (newVal.length >= 2) {
          this.$nextTick(() => {
            this.startBannerAutoPlay();
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeUnmount() {
    this.clearBannerTimer();
  },
  methods: {
    goToBanner(index) {
      if (this.bannerCurrent === index) return;

      this.bannerCurrent = index;
      this.moveBanner();

      this.clearBannerTimer();
      this.startBannerAutoPlay();
    },
    // 原生轮播自动播放
    startBannerAutoPlay() {
      if (this.swiperList.length <= 1) return;
      this.bannerTimer = setInterval(() => {
        this.bannerCurrent++;
        this.moveBanner();

        // 无缝衔接：滑到克隆图时瞬间跳回真实第一张
        if (this.bannerCurrent == this.swiperList.length) {
          setTimeout(() => {
            this.bannerCurrent = 0;
            const wrapper = this.$refs.bannerWrapper;
            if (wrapper) {
              wrapper.style.transition = 'none'; 
              wrapper.style.transform = `translateX(0%)`;
            }
          }, 500);
        }
      }, 3000);
    },
    moveBanner() {
      const wrapper = this.$refs.bannerWrapper;
      if (wrapper) {
        wrapper.style.transition = 'transform 0.5s ease'; 
        wrapper.style.transform = `translateX(-${this.bannerCurrent * 100}%)`;
      }
    },
    // 清除轮播
    clearBannerTimer() {
      clearInterval(this.bannerTimer);
    },

  }
};
</script>

<style lang="less" scoped>
.banner-swiper-native {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
}

.banner-wrapper {
  height: 100%;
  display: flex;
  transition: transform 0.5s ease;
}

.banner-slide {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
}

.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}


.flex {
  display: flex;
  align-items: center;
}

.flex-cs {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dotall {
  gap: 10px;
  position: absolute;
  bottom: 58px;
  left: 110px;
}

.dot {
  width: 60px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 20px;

  &.active {
    background: #fff;
  }
}
</style>
